import * as Turf from '@turf/turf'
import GeoJSON from 'geojson'

import { Coordinates } from '@/domain/protocols/Coordinates'

export const makeGeoJsonTocTodFeatureCollection =
  (distanceOnStage: number, routeLegCoordinates: Coordinates[]) => (): GeoJSON.FeatureCollection => {
    const pointFeatureArray: GeoJSON.Feature[] = []

    const previousWaypoint = routeLegCoordinates[0]
    const nextWaypoint = routeLegCoordinates[1]

    const point = Turf.along(Turf.lineString([previousWaypoint.toArray(), nextWaypoint.toArray()]), distanceOnStage, {
      units: 'nauticalmiles'
    })

    pointFeatureArray.push({
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Point',
        coordinates: point.geometry.coordinates
      }
    })

    return {
      type: 'FeatureCollection',
      features: pointFeatureArray
    }
  }
